export class GDScriptLanguage
{
  public static readonly token ="gdscript";

  public static readonly keywords:string[] = 
  [
    "var","new","void","short","long","uint",
    "float","int","byte","bool","double","string",
    "extends", "func", "pass","await",
    "class_name"
  ]
  
  public static keywords2:string[] = 
  [    
    "Rokojori", "Godot","Export",
    "RJ_Action", "GDScriptAction",

    "Vector2","Vector3","Vector4",
    "Transform3D",
    
    "Node","Node3D","Node2D",

    "Resource",
    
    "Action","ActionList","ActionSequence", 
    "SequenceAction","Parallel"

  ]
  
}